import actions from '@/store/modules/style/actions.js'
import getters from '@/store/modules/style/getters.js'
import mutations from '@/store/modules/style/mutations.js'

/**
 * @returns {object}
 */
const getDefaultState = () => ({
  styles: [],
  customTags: [],
  styleMetaFilters: {},
  styleHubFilters: {},
  stylesPaginatedPage: 1,
  stylesPaginatedLimit: 20,
  hasReachedStylesPaginatedEnd: false
})

export default {
  actions,
  getters,
  mutations,
  state: getDefaultState()
}

export { getDefaultState }
